import UserAndUserGroupManageComponent, { UserAndUserGroupManagePropsType } from './UserAndUserGroupManageComponent';

const CustomComponent = (props: any) => {
    const { userId, closeModal } = props;
    const apiId = 'userArea';
    //表头
    const columnsHead = [
        {
            title: '用户',
            dataIndex: 'user',
            render: (text: any) => (typeof text !== "undefined" && text !== null ?
                text.userName :
                '')
        },
        {
            title: '地区',
            dataIndex: 'area',
            render: (text: any) => (typeof text !== "undefined" && text !== null ?
                text.areaName :
                '')
        }
    ];
    let extendProps: UserAndUserGroupManagePropsType = {
        mode: 'user',
        titleName: '用户地区管理',
        apiId,
        userOrUserGroupId: userId,
        columnsHead,
        closeModal,
        options: {
            showDefault: true
        }
    }

    return (
        <>
            <UserAndUserGroupManageComponent extendData={extendProps} ></UserAndUserGroupManageComponent>
        </>
    )
}

export default CustomComponent;